// File: cgp-breadcrumbs.component.ts
// Author: Joseph M Diaz
// Date: 5/1/2017
// Desc: CGP Breadcrumbs module.
// Other Contributors:

import { Component, OnDestroy } from '@angular/core';

import { CgpBreadcrumbsService } from './cgp-breadcrumbs.service';

@Component({
    selector: 'cgp-breadcrumbs',
    templateUrl: './cgp-breadcrumbs.template.html',
    styleUrls: ['./cgp-breadcrumbs.style.scss']
})
export class CgpBreadcrumbsComponent {
    breadcrumbs = [];
    show = true;
    showBreadcrumbs = true;

    constructor(private readonly cgpBreadcrumbsService: CgpBreadcrumbsService) {
        this.cgpBreadcrumbsService.breadcrumbsComponent = this;
    }
}